import { doc, deleteDoc } from 'firebase/firestore';
import { db, auth } from '../../../config/firebase';

export async function deleteBook(bookId) {
  try {
    const userId = auth.currentUser?.uid;
    if (!userId) throw new Error('User must be logged in to delete books');
    
    if (!bookId) throw new Error('Book ID is required');

    const bookRef = doc(db, 'books', bookId);
    await deleteDoc(bookRef);
    
    return { success: true };
  } catch (error) {
    console.error('Error deleting book:', error);
    throw error;
  }
}